import { Component, OnInit, Input } from '@angular/core';
import { EnvService } from 'src/app/service/env.service';
import WireTransferDetail from '../../../assets/jsondata/wire-transfer-detail.json';
import { UtilService } from '../../service/util.service';
import { AuthenticationService } from 'src/app/service/authentication.service';
import { BillingService } from 'src/app/service/billing.service';

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.scss']
})
export class InvoiceComponent implements OnInit {

  readonly LOCALE = this.env.LOCALE;

  @Input() invoice: any;
  invoiceStatus = ["PAID", "PENDING"];

  wireTransferDetail: any;
  wireTransferAddress: Array<Array<string>>;
  account: any;

  constructor(private env: EnvService, public utilService: UtilService, private authService: AuthenticationService, public billingService: BillingService) { }

  ngOnInit() {
    this.account = this.authService.accountData;
     
    // if (this.billingService.getIsConexioBankTransferAccountID(this.invoice?.accountId)) {
    if (this.billingService.getIsConexioBankTransferAccountID(this.account?.id)) {
      this.wireTransferAddress = [
        ['Bank Name:', WireTransferDetail[1].bankName],
        ['Address:', WireTransferDetail[1].bankAddress],
        ['Account Name:', WireTransferDetail[1].accountToCredit],
        ['Account Number:', WireTransferDetail[1].accountNumber],
        ['ACH Routing Number:', WireTransferDetail[1].achRoutingNumber],
        ['Wire Transfer Routing Number:', WireTransferDetail[1].wireTransferRoutingNumber]
      ]
    } else {
      this.wireTransferAddress = [
        ['Bank Name:', WireTransferDetail[0].bankName],
        ['Bank Address:', WireTransferDetail[0].bankAddress],
        ['ABA/Routing Number:', WireTransferDetail[0].routingNumber],
        ['SWIFT:', WireTransferDetail[0].swift],
        ['Account to Credit:', WireTransferDetail[0].accountToCredit],
        ['Account Number:', WireTransferDetail[0].accountNumber]
      ];
    }
  }

  isLicenseOrFlatOrPrepaid(packageRatePlanType: string): boolean {
    return packageRatePlanType === 'LICENSE_BASED' ||
      packageRatePlanType === 'FLAT_RATE' ||
      packageRatePlanType === 'PREPAID';
  }

}
